import React from 'react';
import { connect } from 'react-redux';
import HeaderSearchList from './indexSearchList';

// Unified header — delegates to the full-featured component.
// Connected to Redux so pages can render <Header /> without passing user/city as props.
const Header = ({ user, ...rest }) => <HeaderSearchList city={user?.city} user={user} {...rest} />;

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps, null)(Header);

